<i18n src="./translations"></i18n>

<template>
  <div :class="['car-selection-banner-wrapper', { pdpPage: isPdp }]">
    <div class="car-selection-banner-inner">
      <div class="car-selection-banner-content">
        <p>
          <span class="car-selection-banner-title qa-CarSelectionBanner__title">
            {{ $t('car-selection-banner.title') }}
          </span>
          {{ $t('car-selection-banner.content') }}
        </p>
        <span
          v-show="carisBarExpanded"
          class="car-selection-banner-arrow qa-CarSelectionBanner__arrow"
        >
          <ChevronRightSvg class="icon" width="30" height="30" />
        </span>
        <Button
          v-show="!carisBarExpanded"
          :modifiers="[
            'secondary',
            'car-selection-banner-button',
            'qa-CarSelectionBanner__button',
          ]"
          :title="$t('car-selection-banner.button')"
          :on-click="openCarisBar"
        />
      </div>
    </div>
  </div>
</template>
<script>
import globalMixin from 'Libs/mixins/globalMixin';
import Button from 'Components/01-atoms/button/Button';
import ChevronRightSvg from 'Components/00-generated/ChevronRightSvg';
import { mapState, mapActions } from 'vuex';
import get from 'lodash/get';

export default {
  name: 'CarSelectionBanner',
  components: {
    Button,
    ChevronRightSvg,
  },
  mixins: [globalMixin],
  computed: {
    ...mapState('carSelection', {
      carisBarExpanded: ({ data }) => data && data.expanded,
    }),
    ...mapState('core', {
      placeholders: (state) => state.placeholders,
      isPdp() {
        const pageType = get(this.placeholders, 'content.component');
        return pageType === 'ProductDetails';
      },
    }),
  },
  methods: {
    ...mapActions('dataLayer', ['trackCarSelectionBanner']),
    openCarisBar() {
      this.$root.$emit('toggleCaris');
      this.trackCarSelectionBanner();
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.car-selection-banner-wrapper {
  background: var(--color-wild-sand);
  border-top: 1px solid var(--color-alto);
}

.car-selection-banner-inner {
  @include pageWidth;

  padding: var(--space-2);
}

.car-selection-banner-title {
  font-size: var(--font-size-LXL);
  color: var(--color-chathamsblue);
  font-weight: bold;
  margin-bottom: 14px;
  display: block;
}

.car-selection-banner-content {
  font-size: var(--font-size-M);
  line-height: 22px;
  display: flex;

  p {
    max-width: 642px;
  }
}

.car-selection-banner-arrow {
  margin-left: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--color-chathamsblue);
  margin-right: 330px;
}

.button--car-selection-banner-button {
  width: 320px;
  height: 40px;
  margin-top: 20px;
  margin-left: auto;
}

@media #{$_mediaMDown} {
  .car-selection-banner-wrapper.pdpPage,
  .car-selection-banner-title,
  .car-selection-banner-arrow {
    display: none;
  }

  .car-selection-banner-content {
    display: block;
    font-size: var(--font-size-S);
    line-height: 16px;

    .button {
      width: 100%;
      display: block !important;
      margin-top: 17px;
    }
  }

  .car-selection-banner-inner {
    padding: 10px 12px;
  }
}
</style>
